import React from "react";
import { motion } from "framer-motion";
import logoUCW from "../assets/img/logo.webp";

const Logo: React.FC = () => (
  <motion.img
    src={logoUCW}
    alt="UC Waves Logo"
    className="
      w-12 h-12              /* mobile-first */
      sm:w-20sm:h-20        /* ≥ 640px */
      md:w-90 md:h-90        /* ≥ 768px */
       object-cover origin-center
    "
    whileHover={{ scale: 1.3 }}
    transition={{
      type: "spring",
      stiffness: 300,
      damping: 20,
    }}
  />
);

export default Logo;
